import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../components/Button";
import Modal from "../../components/Modal";
import ErrorSuccessModal from "../../components/Modal/ErrorSuccessModal";
import ReportDownload from "../../components/TopUpTransactions/ReportDownload";
import TransactionHeader from "../../components/TopUpTransactions/TransactionHeader";
import TransactionTable from "../../components/TopUpTransactions/TransactionTable";
import TotalCard from "../../components/TotalCard";
import { Colors } from "../../config/Constants";
import { getFormattedTopUpsTransaction } from "../../helper";
import {
  getTopUpsTransaction,
  getTopUpTransactionCounts,
} from "../../services/transactionService";
const downloadIcon = require("../../assets/images/download-icon.png");

const LIMIT = 10;

const TopUpTransactions = () => {
  const [responseData, setResponseData] = useState([]);
  const [totalTodayTopUps, setTotalTodaysTopUps] = useState(0);
  const [totalTopUps, setTotalTopUps] = useState(0);
  const [totalTodaysAmount, setTodaysTotalAmount] = useState(0);
  const [totalYesterdayTopUps, setTotalYesterdaysTopUps] = useState(0);
  const [totalYesterdaysAmount, setYesterdaysTotalAmount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState("");
  const [isError, setIsError] = useState(false);
  const [dateModal, setOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState({
    heading: "",
    subHeading: "",
  });
  const [isTableDataLoading, setTableDataLoading] = useState(false);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    fetchTopUpTransactions(page, LIMIT, searchQuery);
  };

  const fetchTopUpTransactions = async (
    activePage: number,
    limitCount: number,
    queryString: string
  ) => {
    setTableDataLoading(true);
    try {
      const { data } = await getTopUpsTransaction(
        activePage,
        limitCount,
        queryString
      );
      setTableDataLoading(false);
      const formattedTopUpsTransactionData = getFormattedTopUpsTransaction(
        data.data
      );
      setResponseData(formattedTopUpsTransactionData);
      setTotalTopUps(data.count);
    } catch (error: any) {
      setTableDataLoading(false);
      if (navigator.onLine) {
        setIsError(true);
        setErrorMessage({
          heading: "Something went wrong.",
          subHeading: error.message,
        });
      }
    }
  };

  const handleTopUpsTransactionSearch = (value: string) => {
    setSearchQuery(value);
    setCurrentPage(1);
    fetchTopUpTransactions(1, LIMIT, value);
  };

  const fetchTopUpCounts = async () => {
    let { data } = await getTopUpTransactionCounts();
    setTodaysTotalAmount(data.data.today.totalAmount);
    setTotalTodaysTopUps(data.data.today.topUpCount);
    setYesterdaysTotalAmount(data.data.yday.totalAmount);
    setTotalYesterdaysTopUps(data.data.yday.topUpCount);
  };

  useEffect(() => {
    fetchTopUpTransactions(currentPage, LIMIT, searchQuery);
    fetchTopUpCounts();
  }, [currentPage, searchQuery]);

  return (
    <TransactionContainer>
      <PaddingWrapper>
        <TransactionHeader
          handleSearch={handleTopUpsTransactionSearch}
          searchQuery={searchQuery}
        />
        <CardWrapper>
          <TotalCard
            cardText="Yesterday's  Top Up"
            cardCount={totalYesterdayTopUps}
            color={Colors.ultraMarineBlue}
            bgcolor={Colors.lightUltraMarineBlue}
          ></TotalCard>
          <TotalCard
            cardText="Yesterday's Amount"
            cardCount={totalYesterdaysAmount}
            color={Colors.ultraMarineBlue}
            bgcolor={Colors.lightUltraMarineBlue}
          ></TotalCard>
          <TotalCard
            cardText="Today's Top Up"
            cardCount={totalTodayTopUps}
            color={Colors.tangerine}
            bgcolor={Colors.lightTangerine}
          ></TotalCard>
          <TotalCard
            cardText="Today's Amount"
            cardCount={totalTodaysAmount}
            color={Colors.tangerine}
            bgcolor={Colors.lightTangerine}
          ></TotalCard>
        </CardWrapper>
        <ButtonWrapperDownload>
          <div>
            <Button
              label="Download"
              variant="filled"
              color={Colors.solidRed}
              size="medium"
              isRounded={true}
              onClick={() => setOpenModal(true)}
              endIcon={downloadIcon}
            />
          </div>
        </ButtonWrapperDownload>
      </PaddingWrapper>

      <TransactionTable
        onPageChange={(page) => handlePageChange(page)}
        totalData={totalTopUps}
        currentPage={currentPage}
        rowsPerPage={LIMIT}
        data={responseData}
        isTableDataLoading={isTableDataLoading}
      />
      {isError && (
        <ErrorSuccessModal
          variant="error"
          heading={errorMessage.heading}
          subHeading={errorMessage.subHeading}
          buttonLabel="Ok"
          setOpenOrClose={setIsError}
          onSubmit={() => setIsError(false)}
        />
      )}
      {dateModal && (
        <Modal setOpenOrClose={setOpenModal} variant={"none"} width="21.2rem">
          <ReportDownload setOpenOrClose={setOpenModal} />
        </Modal>
      )}
    </TransactionContainer>
  );
};

const PaddingWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    padding: 1.5rem;
    padding-bottom: 0;
  }
`;

const ButtonWrapperDownload = styled.div`
  display: flex;
  margin: 0.75rem 0;
  margin-top: 2.25rem;
  justify-content: flex-end;
  > div {
    width: fit-content;
    > div > button {
      padding-right: 1rem;
      padding-left: 1rem;
    }
  }
  @media only screen and (max-width: 768px) {
    > div {
      width: 100%;
    }
  }
`;

const CardWrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  overflow-x: auto;
  &::-webkit-scrollbar {
    width: 0.875rem;
    -webkit-appearance: none;
  }

  &::-webkit-scrollbar-thumb {
    height: 3.625rem;
    border: 4px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 0.625rem;
    background-color: #000000;
  }
  @media only screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const TransactionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export default TopUpTransactions;
